import type { GuideLink, GuideSection, TourStep } from '../types';

// Small builders shared by the menu-section guides (8 October 2026). Every key lives under guide.<guide>.*.

export function builders(guide: string) {
  const link = (key: string, to: string): GuideLink => ({ labelKey: `guide.${guide}.link.${key}`, to });
  const howLink = (key: string, tour: string): GuideLink => ({ labelKey: `guide.${guide}.link.${key}`, tour });
  const step = (id: string, route: string | undefined, target?: string, links?: GuideLink[]): TourStep => ({
    route, target, links, titleKey: `guide.${guide}.tour.${id}.title`, bodyKey: `guide.${guide}.tour.${id}.body`
  });
  const how = (tour: string, id: string, route: string | undefined, target: string | undefined, opts: { open?: string; links?: GuideLink[] } = {}): TourStep => ({
    route, target, open: opts.open, links: opts.links,
    titleKey: `guide.${guide}.howto.${tour}.${id}.title`, bodyKey: `guide.${guide}.howto.${tour}.${id}.body`
  });
  const section = (id: string, paragraphs: number, notes: number, links: GuideLink[]): GuideSection => ({
    id,
    titleKey: `guide.${guide}.s.${id}.title`,
    bodyKeys: Array.from({ length: paragraphs }, (_, i) => `guide.${guide}.s.${id}.p${i + 1}`),
    noteKeys: Array.from({ length: notes }, (_, i) => `guide.${guide}.s.${id}.note${i + 1}`),
    links
  });
  const howTo = (id: string, steps: TourStep[]) => ({
    id, titleKey: `guide.${guide}.howto.${id}.title`, hintKey: `guide.${guide}.howto.${id}.hint`, steps
  });
  return { link, howLink, step, how, section, howTo };
}
